export const usePreviousDate = date => {
  const display = [];
  for (let i = 0; i <= date.date(0).day(); i++) {
    display.push(date.date(0).subtract(i, 'day'));
  }
  return display.sort((a, b) => a.date() - b.date());
};

export const useCurrentDate = (date) =>
	Array.from(
		{
			length: date.daysInMonth(),
		},
		(v, k) => date.date(k + 1)
	);

export const useNextDate = date => {
  const display = [];
  for (let i = 1; i <= 42 - (usePreviousDate(date).length + date.daysInMonth()); i++) {
    display.push(date.date(i).month(date.month()).add(1, 'month'));
  }
  return display;
};

export const useDisableDate = (date, { disableDate }) => typeof disableDate === 'function' ? disableDate(date.toDate()) : false;

export const useBetweenRange = (date, { previous, next }) => {
  let pattern;
  if (previous.isAfter(next, 'date')) {
    pattern = '(]';
  } else {
    pattern = '[)';
  }
  return !!(date.isBetween(previous, next, 'date', pattern) && !date.off);
};

export const useToValueFromString = (date, { formatter }) => date.format(formatter.date);

export const useToValueFromArray = ({ previous, next }, { formatter, separator }) => `${previous.format(formatter.date)}${separator}${next.format(formatter.date)}`;

export const useDirective = binding => {
  const { instance, arg, value } = binding;
  document.body.addEventListener('click', $event => {
    if ($event.target.classList.contains('calendar-picker--overlay')) {
      return (instance.isShow = false);
    } else {
      if (instance.DatepickerRangeRef) {
        const { autoApply, previous, next } = instance;
        const target = $event.target.classList.contains('calendar-days__day-btn');
        if (target && autoApply && !previous && !next) {
          return (instance.isShow = false);
        }

        return (instance.isShow =
          instance.DatepickerRangeRef.contains($event.target) ||
          document.getElementById(value) === $event.target ||
          value === $event.target);
      }
      return (instance.isShow = true);
    }
  });
};

export const useVisibleViewport = el => {
  const { right } = el.getBoundingClientRect();
  const vWidth = window.innerWidth || document.documentElement.clientWidth;

  return right < vWidth;
};
